<template>
  <div class="content">
    <router-view></router-view>
  </div>
</template>
<script>
import { getWxConfig } from "@/api/eating.js";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {};
  },
  async created() {
    let url = window.location.href.split("#")[0];
    const obj = await getWxConfig(url);
    const config = obj.data;
    let { appid, nonceStr, signature, timestamp } = config;
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appid, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名
      jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
       openTagList: ["wx-open-launch-weapp"]
    });
    wx.error(function(res) {
      console.log("验证失败返回的信息:", res);
    });
  }
};
</script>
<style lang="less">
body {
  background: #fff;
  margin: 0;
}
</style>

